import React from 'react';

import { IIconProps, TIconType } from '../interface';

const TaskDoneIcon: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='20'
			viewBox='0 0 20 20'
			width='20'
			{...props?.innerSvgProps}
		>
			<g
				clipPath='url(#clip0_25731_95291)'
			>
				<path
					d='M9.99984 1.66602C8.35166 1.66602 6.7405 2.15476 5.37009 3.07044C3.99968 3.98611 2.93157 5.2876 2.30084 6.81032C1.67011 8.33304 1.50509 10.0086 1.82663 11.6251C2.14817 13.2416 2.94185 14.7265 4.10728 15.8919C5.27272 17.0573 6.75758 17.851 8.37409 18.1726C9.99059 18.4941 11.6661 18.3291 13.1889 17.6983C14.7116 17.0676 16.0131 15.9995 16.9288 14.6291C17.8444 13.2587 18.3332 11.6475 18.3332 9.99935C18.3289 7.79051 17.4496 5.67336 15.8877 4.11147C14.3258 2.54958 12.2087 1.67025 9.99984 1.66602ZM13.9662 8.54101L9.27067 13.0282C9.14928 13.1424 8.98861 13.2055 8.82195 13.2045C8.7405 13.2056 8.65961 13.1907 8.58397 13.1604C8.50833 13.1302 8.43943 13.0852 8.38125 13.0282L6.03349 10.7846C5.96838 10.7278 5.91542 10.6584 5.8778 10.5806C5.84019 10.5028 5.81869 10.4182 5.81461 10.3319C5.81052 10.2455 5.82393 10.1593 5.85404 10.0783C5.88414 9.99728 5.93031 9.9232 5.98977 9.86049C6.04923 9.79778 6.12076 9.74775 6.20006 9.71339C6.27935 9.67903 6.36478 9.66106 6.45119 9.66056C6.53761 9.66006 6.62323 9.67703 6.70292 9.71047C6.78261 9.7439 6.85472 9.7931 6.9149 9.85512L8.82195 11.674L13.0848 7.61153C13.2094 7.50278 13.3713 7.44643 13.5365 7.45425C13.7017 7.46206 13.8575 7.53345 13.9713 7.65347C14.0852 7.7735 14.1482 7.93287 14.1472 8.09828C14.1462 8.26369 14.0814 8.42232 13.9662 8.54101Z'
					fill='#29A347'
				/>
			</g>
			<defs>
				<clipPath
					id='clip0_25731_95291'
				>
					<rect
						fill='white'
						height='20'
						width='20'
					/>
				</clipPath>
			</defs>
		</svg>
	);
};

export default TaskDoneIcon;
